
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 0h-2.316l-3.243 16.507L91.198.001h-2.315l4.446 21.682h.002v6.487h2.221v-6.487h.002L100 0zM66.873 0h-2.222V28.17h9.389v-1.88h-7.167V0zM3.56 0H0v1.882h3.56V28.17h2.223V1.882h3.56V0H3.562zM20.502 18.784c.961 0 1.74-.78 1.74-1.74V1.881h.003V0h-9.347V28.17h2.222v-9.386h2.063l3.503 9.386H23l-3.503-9.386H20.5zM15.12 1.882h4.9v14.353c0 .357-.29.647-.647.647H15.12v-15zM61.054 0h-9.347v28.17h2.221v-9.386h5.418c.966 0 1.75-.78 1.75-1.74V.003h-.043V.002h.001zm-2.84 16.882h-4.285v-15h4.935v14.353a.649.649 0 01-.65.647zM32.987 0v26.268h-4.285a.648.648 0 01-.65-.647V0H25.82v26.428c0 .962.783 1.74 1.75 1.74h7.64V.002h-2.223zM40.996 25.622V13.177h5.672v-1.88h-5.672V1.899h6.858V.018h-6.858V0h-2.233v26.428c0 .962.784 1.74 1.75 1.74h7.64v-1.901h-6.507a.648.648 0 01-.65-.647zM83.32 0h-4.095c-.893 0-1.63.716-1.683 1.634l-.558 9.662h-4.211v1.88h4.102L76.01 28.17h2.15l.887-14.992h4.452l.886 14.992h2.15L85.002 1.633C84.949.715 84.212 0 83.319 0zm-4.163 11.297l.52-8.8c.02-.346.3-.616.637-.616h1.915c.337 0 .616.27.637.617l.52 8.799h-4.23z","fill":"#2569F6"}})])
          )
        }
      }
    